import { Col, Row } from "antd";
import React from "react";

export const StyledTypographySHB = () => {
    return (
        <>
            <div>

                <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                    <Row className="align-center">
                        <Col span={12}>
                            <div>
                                <p className="fw-600 text-color-berry mb-0 d-inline-block">Font Family</p>
                                <h1 className="type-face-heading">Inter</h1>
                            </div>
                            <div>
                                <p className="fw-600 text-color-berry mb-0 d-inline-block">Font Sizes</p>
                                <h4 className="fw-400">Regular (400)</h4>
                                <h4 className="fw-600">SemiBold (600)</h4>
                                <h4 className="fw-900">BlackBold (900)</h4>
                            </div>
                        </Col>

                        <Col span={12}>
                            <div className="styled-typeface-demo fw-600 flex-center ">
                                Aa
                            </div>
                        </Col>
                    </Row>
                </div>

                <div>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H1</strong>, Font Size ~ <strong>56px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h1 className="mb-0">Heading 1</h1>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H2</strong>, Font Size ~ <strong>48px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h2 className="mb-0">Heading 2</h2>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H3</strong>, Font Size ~ <strong>40px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h3 className="mb-0">Heading 3</h3>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H4</strong>, Font Size ~ <strong>32px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h3 className="mb-0">Heading 4</h3>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H5</strong>, Font Size ~ <strong>28px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h4 className="mb-0">Heading 5</h4>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>H6</strong>, Font Size ~ <strong>24px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <h5 className="mb-0">Heading 6</h5>
                            </div>
                        </Col>

                        <Col span={12}>
                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>P</strong>, Font Size ~ <strong>16px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <p>Paragraph Text</p>
                            </div>

                            <div className="ground-color-delta border-rounded-xl px-5 py-5 mt-4">
                                <span className="type-face-info text-color-berry">Font type ~ <strong>Label</strong>, Font Size ~ <strong>20px</strong>,  font weight ~ <strong>400</strong>,</span>
                                <label>Label Text</label>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        </>
    )
}